import { toast } from "sonner";
import { api, errMsg } from "./api";

export const fetchPdfUrl = async (id) => {
  const { data } = await api.get(`/garanzie/${id}/pdf`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
};

export const downloadPdf = async (id, numero) => {
  try {
    const url = await fetchPdfUrl(id);
    const a = document.createElement("a");
    a.href = url; a.download = `Contratto_${numero}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (e) { toast.error(errMsg(e)); }
};
